import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { SharedDataService } from 'src/app/shared/services/sharedata.service';
@Component({
  selector: 'app-cc-alert',
  templateUrl: './cc-alert.component.html',
  styleUrls: ['./cc-alert.component.scss']
})
export class CcAlertComponent implements OnInit {

  featureTags = {};
  loggedIn: boolean = false;
  creditCardsNotFound: boolean = false;
  creditCards = [];
  ccExpired:boolean = false;
  ccDeclined:boolean;

  constructor(private apiService: ApiService, public sharedDataService: SharedDataService, private ref: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags")); 
    this.loggedIn = this.apiService.loggedIn();
    this.apiService.isLoggedIn.subscribe((data: any) => {
        this.loggedIn = data.loggedIn;
        this.getCreditCardLists();
    });
    
    this.getCreditCardLists();
    this.sharedDataService.triggerCreditCard$.subscribe(resp =>{
        this.getCreditCardLists();
    })

  }

  getCreditCardLists() {
    if(this.loggedIn === true){
      this.creditCardsNotFound = false;
      this.apiService.getCreditCardList().subscribe(data => {
        if(data['response']['status'] === 1) {
          this.creditCards = data['response']['data']['credit_cards'];          
          const defaultCard = this.creditCards.find(card => card.default === true);
          if(!!this.featureTags && this.featureTags['ftag_sf_card_expiry']){              
            this.ccExpired = data['response']['data']['is_card_expired'];   
            if(data['response']['data']['declineCount'] >= 2){
              this.ccDeclined = true;              
            }else{
              this.ccDeclined = false;
            }
          }else{
             if (defaultCard) {
              this.ccExpired = this.isCardExpired(defaultCard.expirydate);            
          } else {
            console.log('No default card found.');
          }
          }
          
        }else {
          if(!!this.featureTags && this.featureTags['ftag_sf_card_expiry']) {
            if(data['response']['status'] === 6){
            this.creditCardsNotFound = true; 
            this.ccDeclined = false; 
            this.ccExpired = false
            this.ref.detectChanges();     
          }
          }
          this.creditCardsNotFound = true;
        }
      }, err => {
        console.log(err)
      })
    }
  }

  isCardExpired(expiryDate: string): boolean {
    const [monthStr, yearStr] = expiryDate.split('/');
    const month = parseInt(monthStr, 10); // Convert to integer safely
    const year = 2000 + parseInt(yearStr, 10); // Add 2000 to handle two-digit years correctly
  
    const expiry = new Date(year, month, 0); // Last day of the expiry month
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Set time to the start of the day
  
    return expiry < today;
  }

}
